import React from 'react';
import './index.style.less';
import PropTypes from 'prop-types';
// import UserInfo from '../components/UserInfo';
import AppScrollbar from '../../AppScrollbar';
import clsx from 'clsx';
import AppVerticalMenu from '../components/AppVerticalNav';
import {useSidebarContext} from '../../../../contexts/AppContextProvider/SidebarContextProvider';
import MainSidebar from '../components/MainSidebar';
import moment from 'moment';

const AppSidebar = ({isCollapsed}) => {
  const {isSidebarBgImage} = useSidebarContext();

  return (
    <MainSidebar
      className={clsx('app-standard-sidebar', {
        'standard-sidebar-img-background': isSidebarBgImage,
      })}
      collapsible
      breakpoint='xl'
      collapsed={isCollapsed}>
      {/* <UserInfo hasColor /> */}
      <AppScrollbar
        className='app-standard-sidebar-scrollbar'
        scrollToTop={false}>
        <AppVerticalMenu />
      </AppScrollbar>
      <span className='sidebar-footer'>
        Copyright &nbsp;
        <a href='https://v2.ltd' target='_blank' rel='noreferrer'>
          V2 Technologies Ltd
        </a>
        &nbsp; {moment().format('YYYY')}
      </span>
    </MainSidebar>
  );
};

export default AppSidebar;

AppSidebar.propTypes = {
  isCollapsed: PropTypes.bool,
};
